module.exports = __webpack_public_path__ + "img/satellite.12b1fea2.png";